/**
 * lightbox.js — Studio 1/1
 * Click-to-enlarge for gallery/story images across the Story category pages
 * (and anywhere else [data-lightbox] is used). Vanilla JS, single delegated
 * click listener on document rather than one listener per image, so it
 * works for any current or future [data-lightbox] element without needing
 * per-section wiring.
 *
 * Usage: wrap an image in a trigger carrying [data-lightbox] and, optionally,
 * [data-lightbox-src] pointing at a larger rendition than the thumbnail
 * (falls back to the thumbnail's own src if omitted).
 *
 * Click the thumbnail to open a full-screen overlay with the enlarged
 * image. Click anywhere in the overlay (backdrop, image, or the close
 * button) — or press Escape — to close it.
 */
(function () {
  'use strict';

  if (window.__studio1of1LightboxInit) return;
  window.__studio1of1LightboxInit = true;

  var overlay, overlayImg, closeBtn, lastFocused;

  function buildOverlay() {
    overlay = document.createElement('div');
    overlay.className = 'lightbox-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Enlarged image');
    overlay.hidden = true;

    overlayImg = document.createElement('img');
    overlayImg.className = 'lightbox-overlay__image';
    overlayImg.alt = '';

    closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'lightbox-overlay__close';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.innerHTML = '&times;';

    overlay.appendChild(closeBtn);
    overlay.appendChild(overlayImg);
    document.body.appendChild(overlay);

    // Any click inside the overlay closes it — backdrop, image, or button
    overlay.addEventListener('click', close);
  }

  function open(src, alt) {
    if (!overlay) buildOverlay();
    lastFocused = document.activeElement;
    overlayImg.src = src;
    overlayImg.alt = alt || '';
    overlay.hidden = false;
    document.body.classList.add('lightbox-open');
    closeBtn.focus();
    document.addEventListener('keydown', onKeydown);
  }

  function close() {
    if (!overlay || overlay.hidden) return;
    overlay.hidden = true;
    overlayImg.src = '';
    document.body.classList.remove('lightbox-open');
    document.removeEventListener('keydown', onKeydown);
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  function onKeydown(e) {
    if (e.key === 'Escape') close();
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-lightbox]');
    if (!trigger) return;
    e.preventDefault();
    var img = trigger.tagName === 'IMG' ? trigger : trigger.querySelector('img');
    var src = trigger.getAttribute('data-lightbox-src') || (img && (img.currentSrc || img.src));
    if (!src) return;
    open(src, img ? img.alt : '');
  });
})();
